import { render, staticRenderFns } from "./p-item.vue?vue&type=template&id=3f27c399&scoped=true&"
import script from "./p-item.vue?vue&type=script&lang=js&"
export * from "./p-item.vue?vue&type=script&lang=js&"
import style0 from "./p-item.vue?vue&type=style&index=0&id=3f27c399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27c399",
  null
  
)

export default component.exports